import { render, staticRenderFns } from "./success-add.vue?vue&type=template&id=c8253d86&scoped=true"
import script from "./success-add.vue?vue&type=script&lang=js"
export * from "./success-add.vue?vue&type=script&lang=js"
import style0 from "./success-add.vue?vue&type=style&index=0&id=c8253d86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8253d86",
  null
  
)

export default component.exports